module.exports = __webpack_public_path__ + "static/img/ls16.f82bd4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark2/ls16.png
// module id = gdVM
// module chunks = 12